import { render, staticRenderFns } from "./VersionFilter.vue?vue&type=template&id=63aa4cac&lang=pug"
import script from "./VersionFilter.vue?vue&type=script&lang=js"
export * from "./VersionFilter.vue?vue&type=script&lang=js"
import style0 from "./VersionFilter.vue?vue&type=style&index=0&id=63aa4cac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports